import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EventsShowcase from './components/EventsShowcase';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import GalleryPreview from './components/GalleryPreview';
import TrustSpeed from './components/TrustSpeed';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-black">
      <Navbar />
      <main>
        <Hero />
        <EventsShowcase />
        <HowItWorks />
        <Features />
        <GalleryPreview />
        <TrustSpeed />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;